import { isAnySupplierItem } from "../order_item/isAnySupplierItem";

import { LinkedDoorOrderItem, OrderItem, SupplierOrderItem } from "../../types";

export function filterAnySupplierItems(
    items: OrderItem[]
): (SupplierOrderItem | LinkedDoorOrderItem)[] {
    return items.filter(isAnySupplierItem);
}
